import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=78f8107b&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Note.vue?vue&type=style&index=1&id=78f8107b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f8107b",
  null
  
)

export default component.exports